import React from 'react';

import { Badge, Icon } from '@sravni/react-design-system';

import styles from '../../review-card.module.scss';

interface IBadgeBlockProps {
  icon: React.ReactNode;
  text: string;
}

export const BadgeBlock: React.FC<IBadgeBlockProps> = ({ icon, text }) => (
  <Badge
    text={
      <React.Fragment>
        <Icon className={styles.badgeIcon} icon={icon} size={16} />
        {text}
      </React.Fragment>
    }
  />
);
